import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import classNames from "classname";
import BreadcrumbsData from "../variables/variables";

const Breadcrumbs = (props) => {
	const router = useRouter();
	const [breadcrumbs, setBreadcrumbs] = useState(null);

	// PROPS VARIABLE
	let propsMiasto = props.miasto;
	let propsPodatek = props.podatek;

	let propsType;
	let extendedUrl = "";
	let siteCode = router.query.siteCode;

	if (BreadcrumbsData.miasta[propsMiasto].index) {
		propsType = "/";
	} else if (BreadcrumbsData.miasta[propsMiasto].witryna) {
		propsType = "/witryna/";
		extendedUrl = "?siteCode=" + siteCode;
	} else {
		propsType = "/" + BreadcrumbsData.miasta[propsMiasto].name.url + "/";
	}

	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	const convertBreadcrumbForStrona = (string) => {
		var s = string;
		var n = s.indexOf("?");
		s = s.substring(0, n != -1 ? n : s.length);
		if (s.startsWith("strona")) {
			const pageNumber = s.split("/")[1];
			return `Strona`;
		}
		return s;
	};

	const convertBreadcrumb = (string) => {
		var s = string;
		var n = s.indexOf("?");
		s = s.substring(0, n != -1 ? n : s.length);

		if (s == "witryna") {
			return "Przyjazne Deklaracje " + BreadcrumbsData.miasta[propsMiasto].name.who;
		} else if (s == "kontakt") {
			return "Kontakt";
		} else if (s == "mapa-strony") {
			return "Mapa strony";
		} else if (s == "deklaracja-dostepnosci") {
			return "Deklaracja dostępności";
		} else if (s == "podatek-od-srodkow-transportowych") {
			return "Podatek od środków transportowych";
		} else if (s == "dt-1-deklaracja-na-podatek-od-srodkow-transportowych") {
			return "Deklaracja DT-1 na podatek od środków transportowych";
		} else if (s == "podatek-od-nieruchomosci") {
			return "Podatek od nieruchomości";
		} else if (s == "podatek-rolny") {
			return "Podatek rolny";
		} else if (s == "podatek-lesny") {
			return "Podatek leśny";
		} else if (s == "oplata-za-gospodarowanie-odpadami-komunalnymi") {
			return "Opłata za gospodarowanie odpadami komunalnymi";
		} else if (s == "dla-mieszkanca") {
			return "Dla Mieszkańca";
		} else if (s == "dla-samorzadu") {
			return "Dla Samorządu";
		} else if (s == "abc-podatkow") {
			return "ABC podatków";
		} else if (s == "jak-to-dziala") {
			return "Jak to działa";
		} else if (s == "wazne-terminy") {
			return "Ważne terminy";
		} else if (s == "aktualnosci") {
			return "Aktualności";
		} else if (s == "wyszukiwarka") {
			return "Wyszukiwarka";
		} else if (s == "deklaracja-dn-1") {
			return "Deklaracja DN-1";
		} else if (s == "druk-in-1") {
			return "Druk IN-1";
		} else if (s == "jak-otrzymac-numer-pesel") {
			return "Jak otrzymać numer PESEL?";
		} else if (s == "autorzy") {
			return "Autorzy";
		} else if (s == "krystyna-gasiorek") {
			return "Krystyna Gąsiorek";
		} else if (s == "najczesciej-zadawane-pytania-faq") {
			return "Najczęściej zadawane pytania (FAQ)";
		} else {
			return "Przyjazne Deklaracje " + BreadcrumbsData.miasta[propsMiasto].name.who;
		}
	};

	useEffect(() => {
		if (router) {
			const linkPath = router.asPath.split("/");
			linkPath.shift();

			let breadcrumbsArray = [];

			const isStronaPath = linkPath.includes("strona");

			if (isStronaPath) {
				linkPath.forEach((path, i) => {
					const isStrona = path === "strona";
					const isStronaWithPage = isStrona && linkPath[i + 1];

					let breadcrumbName;
					let href;

					if (isStronaWithPage) {
						const pageNumber = linkPath[i + 1];
						breadcrumbName = `Strona ${pageNumber}`;
						href = "/" + linkPath.slice(0, i + 2).join("/");
						breadcrumbsArray.push({ breadcrumb: breadcrumbName, href });
						return;
					} else if (!isStrona) {
						breadcrumbName = convertBreadcrumb(path);
						href = "/" + linkPath.slice(0, i + 1).join("/");
						breadcrumbsArray.push({ breadcrumb: breadcrumbName, href });
					}
				});

				breadcrumbsArray = breadcrumbsArray.filter((item, index) => {
					if (
						index === breadcrumbsArray.length - 1 &&
						item.breadcrumb.includes("Przyjazne Deklaracje")
					) {
						return false;
					}
					return true;
				});
			} else {
				breadcrumbsArray = linkPath.map((path, i) => {
					return {
						breadcrumb: convertBreadcrumb(path),
						href: "/" + linkPath.slice(0, i + 1).join("/"),
					};
				});
			}

			setBreadcrumbs(breadcrumbsArray);
		}
	}, [router]);

	if (!breadcrumbs) {
		return null;
	}

	return (
		<>
			<section
				className={classNames("pd-breadcrumbs", {
					"pd-breadcrumbs--light": props.layout === "light",
					"pd-breadcrumbs--dark": props.layout === "dark",
				})}
			>
				<nav aria-label="Breadcrumbs">
					<ul className="pd-breadcrumbs__list">
						{propsMiasto === "PRZYJAZNEDEKLARACJE" && (
							<li>
								<Link href="/" title="Przyjazne Deklaracje">
									Przyjazne Deklaracje
								</Link>
							</li>
						)}

						{breadcrumbs.map((breadcrumb, i) => (
							<React.Fragment key={i}>
								{props.title ? (
									(i >= 0) & (i < breadcrumbs.length - 2) ? (
										<li>
											<Link href={breadcrumb.href + "/"} aria-label={breadcrumb.breadcrumb}>
												{breadcrumb.breadcrumb}
											</Link>
										</li>
									) : null
								) : (i >= 0) & (i < breadcrumbs.length - 1) ? (
									<li>
										<Link href={breadcrumb.href + "/"} aria-label={breadcrumb.breadcrumb}>
											{breadcrumb.breadcrumb}
										</Link>
									</li>
								) : null}

								{i === breadcrumbs.length - 1 && props.title && (
									<li>
										<Link href={breadcrumb.href} title={props.title}>
											{props.title}
										</Link>
									</li>
								)}
							</React.Fragment>
						))}
					</ul>
				</nav>
			</section>
		</>
	);
};

export default Breadcrumbs;
